module.exports = __webpack_public_path__ + "dist/assets/browser-firefox.927fe9375969505609b8796e0ada0342.png";